import React from 'react'
import PropTypes from 'prop-types'
import ContentWrapper from '../ContentWrapper'
import Block from '../Block'
import Column from '../Column'
import markdown from '../../lib/remark'
import { StaticQuery, graphql } from 'gatsby'
import moment from 'moment'
import twix from 'twix'

const propTypes = {
    className: PropTypes.string,
}

const defaultProps = {
    className: '',
}

export default function EventList({ title, className }) {
    return <div>eventlist</div>
    // return (
    //     <StaticQuery
    //         query={graphql`
    //             query EventListQuery {
    //                 datocms {
    //                     allEvents {
    //                         title
    //                         body
    //                         from
    //                         to
    //                         image {
    //                             url
    //                         }
    //                     }
    //                 }
    //             }
    //         `}
    //         render={data => (
    //             <ContentWrapper className={className}>
    //                 {title && (
    //                     <Block>
    //                         <Column column="w-full">
    //                             <h2 className="text-6xl  font-normal  text-concord-dark-green">
    //                                 {title}
    //                             </h2>
    //                         </Column>
    //                     </Block>
    //                 )}
    //                 <Block className={`${title ? 'mt-5' : ''}`}>
    //                     {data.datocms.allEvents.map(el => (
    //                         <div
    //                             key={el.id}
    //                             className="mb-5  text-justify  js-event-list-item"
    //                         >
    //                             <span className="text-concord-grey">
    //                                 {moment(el.from)
    //                                     .twix(el.to, true)
    //                                     .format({
    //                                         hideTime: true,
    //                                         monthFormat: 'MMMM',
    //                                         dayFormat: 'Do',
    //                                         allDay: true,
    //                                         implicitYear: false,
    //                                     })}
    //                             </span>
    //                             <h3 className="text-concord-dark-green  font-normal  text-2xl">
    //                                 {el.title}
    //                             </h3>
    //                             <span className="text-concord-grey">
    //                                 {el.body}
    //                             </span>
    //                         </div>
    //                     ))}
    //                 </Block>
    //             </ContentWrapper>
    //         )}
    //     />
    // )
}

EventList.propTypes = propTypes
EventList.defaultProps = defaultProps
